import { connect } from 'react-redux';
import AnalyzeDocument from './AnalyzeDocument';

const mapStateToProps = ({ documentAnimation }) => ({
    run: documentAnimation.run,
    abort: documentAnimation.abort,
    cancel: documentAnimation.cancel
});

export default connect(mapStateToProps)(AnalyzeDocument);
